var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"0"}},[_c('b-navbar',[_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('img',{staticClass:"logo-top",attrs:{"src":require("@/assets/LIZ_Wallpaper.png")}})]),_c('div',{staticClass:"nav-text"},[_c('h5')])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }